// component/Geospatial/FilterBar.jsx
import React from 'react';
import { FACILITY_TYPE_OPTIONS } from '../../api/facilitiesApi';

// Market-registry records that aren't bucketed into an existing facility type
// (see MARKET_TYPE_TO_GEO_TYPE in GeospatialOverview.jsx) still need a pill,
// otherwise they can never be isolated from "All".
const MARKET_ONLY_TYPES = [
  { key: 'Market', label: 'Market' },
  { key: 'Processing', label: 'Processing' },
];

const ALL_TYPES = [
  { key: null, label: 'All' },
  ...FACILITY_TYPE_OPTIONS.map(({ value, label }) => ({ key: label, label })),
  ...MARKET_ONLY_TYPES,
];

export default function FilterBar({ activeType, onTypeChange }) {
  return (
    <div className="mb-3.5 flex items-center gap-2 overflow-x-auto pb-1">
      {/* State dropdown placeholder */}
      {/* <div className="flex items-center gap-1.5 px-3.5 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 font-medium cursor-pointer min-w-[72px] shadow-sm select-none">
        All
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M6 9l6 6 6-6" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div> */}

      {/* Type pills */}
      {ALL_TYPES.map(({ key, label }) => {
        const isActive = activeType === key;
        return (
          <button
            key={String(key)}
            onClick={() => onTypeChange(key)}
            className={`whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition-all cursor-pointer border-none
              ${isActive
                ? 'bg-green-600 text-white shadow-md shadow-green-600/30'
                : 'bg-transparent text-gray-500 hover:text-gray-700'
              }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
